import React, { useEffect } from "react"
import { graphql, type PageProps } from "gatsby"
import { getPageData } from "../../../helpers/getPageData"
import { type PageData } from "../../../interfaces/pageProps"

import Layout from "../../../components/Layouts/mainPage"
import { Header } from "../../../components/Headers/HeaderSovcombank"
import { Banner } from "../../../components/Banners/180dnejBezProcentov"
import { FourAdvantagesPoints } from "../../../components/FourAdvantagesPoints"
import { HowSteps } from "../../../components/HowSteps"
import { STEPS_CREDIT_CARD_MEDIA } from "../../../components/HowSteps/helpers"
import { FormPKW } from "../../../components/FormPKW"
import Benefits from "../../../components/BenefitsRefin"
import { CREDIT_CARD_MEDIA_180_DNEJ } from "../../../components/BenefitsRefin/helper"
import { BottomCta } from "../../../components/BottomCtaZadolzhennostej"
import { NewFooter } from "../../../components/NewFooter"

const seoData = {
  title: "Бесплатная кредитная карта от Совкомбанка",
  description:
    "Оформите кредитную карту Совкомбанка с бесплатным снятием наличных в любых банкоматах! Выпуск и обслуживание - всегда бесплатно. Оформите заявку на кредитную карту не выходя из дома!",
}

const FOUR_POINTS_TITLE = <>Преимущества кредитной карты от&nbsp;Совкомбанка:</>

const HOW_TO_GET_TITLE = <>Как оформить кредитную карту&nbsp;Совкомбанка</>

const FORM_TITLE = (
  <>
    Оформить заявку
    <br />
    на кредитную карту
  </>
)

const FORM_SUBTITLE = <>Не выходя из дома, за несколько кликов</>

const BENEFITS_TITLE = <>Преимущества кредитной карты&nbsp;Совкомбанка</>

const BOTTOM_CTA_TEXT = (
  <>
    Кредитная карта
    <br />с бесплатным снятием наличных
  </>
)

export default function Page({ data }: PageProps<PageData>) {
  const { ligal, noIndex } = getPageData(data)

  // Получение первой страницы на которую зашел
  useEffect(() => {
    if (!sessionStorage.getItem("firstURL")) {
      sessionStorage.setItem("firstURL", document.URL)
    }
  }, [])
  return (
    <Layout noHeader noFooter noIndex={noIndex} seoData={seoData}>
      <Header />
      <Banner orderNum="1" />
      <FourAdvantagesPoints
        withTitle
        variant="creditCardMedia180Dnej"
        title={FOUR_POINTS_TITLE}
        orderNum="2"
      />
      <HowSteps title={HOW_TO_GET_TITLE} items={STEPS_CREDIT_CARD_MEDIA} orderNum="3" />
      <FormPKW
        progressBar
        isGreenApprove
        title={FORM_TITLE}
        subTitle={FORM_SUBTITLE}
        longTitle
        formBtnText="Оформить"
        orderNum="4"
        productName="Кредитная Карта"
        emptyForm={false}
        variant="creditCardMedia"
      />
      <Benefits
        headTitle={BENEFITS_TITLE}
        dataContent={CREDIT_CARD_MEDIA_180_DNEJ}
        variantStyle="creditCardMedia180Dnej"
        orderNum="5"
      />
      <BottomCta
        buttonText="Оформить"
        variantStyles="creditCard180Dnej"
        text={BOTTOM_CTA_TEXT}
        orderNum="6"
      />
      <NewFooter ligal={ligal} orderNum="7" />
    </Layout>
  )
}

export const query = graphql`
  query {
    admin {
      page(url: "https://halvacard.ru/order/credit-card/media/180-dnej-bez-procentov/") {
        url
        ligal {
          text
        }
        notIndex
      }
    }
  }
`
